import script from "./PersonalRelationships.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalRelationships.vue?vue&type=script&setup=true&lang=js"

import "./PersonalRelationships.vue?vue&type=style&index=0&id=14336d86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14336d86"]])

export default __exports__